declare namespace $ {

	export class $shm_hitalama_text extends $mol_text {
	}
	
}

//# sourceMappingURL=text.view.tree.d.ts.map